'use strict';
import * as $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigation$002ejs from "@ui5/webcomponents-fiori/dist/SideNavigation.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$() {
  this.Dh = null;
  $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigation$002ejs.default;
  this.Dh = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-side-navigation", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$ as $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_SideNavigation$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_SideNavigation$ as $h_Lbe_doeraene_webcomponents_ui5_SideNavigation$ };
$h_Lbe_doeraene_webcomponents_ui5_SideNavigation$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.Dh;
});
var $d_Lbe_doeraene_webcomponents_ui5_SideNavigation$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_SideNavigation$, "be.doeraene.webcomponents.ui5.SideNavigation$", ({
  go: 1,
  ar: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_SideNavigation$ as $d_Lbe_doeraene_webcomponents_ui5_SideNavigation$ };
var $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$;
function $m_Lbe_doeraene_webcomponents_ui5_SideNavigation$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_SideNavigation$)) {
    $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$ = new $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_SideNavigation$ as $m_Lbe_doeraene_webcomponents_ui5_SideNavigation$ };
